import React from 'react'
import './about.css'




const About = () => {
  return (
    <section id='about'>
        
          <span className='about-heading'>What I do</span>
      
          <div className='info'>
             <p>As a skilled web designer, i craft an exceptional digital experience 
                that captivate audiences and drive results. With keen eyes for details 
                and a passion for innovation, i create visually stunning and intuitive websites
                that elevate brands and inspire engagement. I am proficient in
                HTML, CSS, Javascript,React js,Express js,Node js & PostgreSql.
             </p>
              
            </div>
    </section>
  )
}

export default About
